// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxItem from './checkbox-item';

function handleChange(item, isSelected) {

    this.onChange(item, isSelected);

}

function setLabel(item) {

    return item.label ? item.label : item.value;

}

const CheckboxList = props =>
    <ul className='checkbox-list'>
        {props.list.map((item, index) =>
            <CheckboxItem
                id={item[props.uid]}
                isLabelTranslated={props.isLabelTranslated}
                isSelected={props.initialState[item[props.uid]] || false}
                key={index}
                label={setLabel(item)}
                onChange={handleChange.bind(props, item)}
            />
        )}
    </ul>;

CheckboxList.displayName = 'CheckboxList';
CheckboxList.propTypes = {
    initialState: PropTypes.object.isRequired,
    isLabelTranslated: PropTypes.bool,
    list: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    uid: PropTypes.string.isRequired
};
CheckboxList.defaultProps = {
    isLabelTranslated: true
};

export default CheckboxList;



// WEBPACK FOOTER //
// ./src/shared/components/checkbox-list-with-label/checkbox-list.js